export const STOREFRONT_API_URL = "/api/2024-07/graphql.json";
export const STOREFRONT_ACCESS_TOKEN = process.env.STOREFRONT_ACCESS_TOKEN;
